import React from "react";

const CseSem4MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 class="mb-1">
          SEMESTER 4 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Mathematics
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1_UUtgRJ7iJtrFR2Ti63W2_A5JaKxKaDA/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1Tlq9MPFnYCxfx3wgK6KT-8ut7TX3WsUr?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Computer architecture organization
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/11XhzYIhsK3bJT4RAxUwkJ0URLchz5sPy/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/12B30V0FM-OrdGbn5xjENcs0LnTeJ21Fp/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1DVhgVxkNAJ54ZmW2Qz5G6zUY3xle1w08/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1jq0XKLy9PWt-u_cMR_eIx6YLe9WNUk0T/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2018
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              DBMS
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1TQx96FOjU6Qh65NY-QMNLxc7OfaLrZQs/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1lVDMAUh9aJRzqSFeCwqDmVTjaclYj02E/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1wW9DNG7yHf_oax3tyTfyroa7YwtxOQfJ/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1RVyhnWXhOyUq56VrX7O0kDfI-AW6-1wG/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/16pyjxBhJ7xFyvFDUgHsHN2-r63P2A7Yl/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1cRGOhLcvuQfiALdcR3PHncT3RlYhzowK/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2019
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Internet Fundamental
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/11JBNnsP2_eP_ArPfPSjv-nqRgsiywA8E/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1LGpO4Ok3SmdUD0_RJ5F-WaSk4CqoIPqd/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1AMFdK0upRuyKfz5pP4F_L96vw5FfR2HU/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1O4a0ZxiTQWo6IriqGIrCazFohPk3weKA/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              OOPS
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1jJg3QWVkIwebQ9yFBcKUs9Z_04_bWmX1/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1gPZ-ZUZTizcwMU3JOFUOs84V9I5Za428/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1clbupK6UEuuvJM1bSPJbsgvJq2k9RBZV/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1FIMqFinEMxKkkJDJmDSfRfhz87JZXPJP/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1IsqTjl3gQxae-SRIAHXy3ajWXYKoi_fI/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/11RFTBs0bPFsv5XUT8n34kBpqDhXG3hoW/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Programming Language
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1SAVH35o6TubV7KxXVMBFT8oOfYiuW6wh/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/15RYhCPrv1iak9SGtbkqyrKI8XwM3Jz6o/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2015
                </button>
              </a>
              <a
                href="https://drive.google.com/file/d/10IyOdJ54VomAqQ9hkHulk4ZTyZyLswqE/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2016
                </button>
              </a>
              <a
                href="https://drive.google.com/file/d/18KmYo65ClmtsmY16VgfRbp93z3li0lbE/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2017
                </button>
              </a>
              <a
                href="https://drive.google.com/file/d/1zJEWb-SemVnOj8_QqkkqWJvdnBXU-CQf/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2018
                </button>
              </a>
              <a
                href="https://drive.google.com/file/d/1rh2i0Pi4Ee9vXb5HquyC_hBubWP7SuHG/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2019
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem4MDU;
